module.exports = __webpack_public_path__ + "media/components/assets/icons/board/arrow_up_sharp-c1747aa262cf0a8e5c1bb2cf0de6b46a.svg";